export default __webpack_public_path__ + "static/media/Art.d4504d3b.svg";